// FAZ F — "Kaydedilmemiş bilgi var mı?" ortak kontrolü.
// Form açılışındaki BAŞLANGIÇ anlık görüntüsü ile şimdiki değerler
// karşılaştırılır; böylece formun kendiliğinden dolu gelen VARSAYILAN
// değerleri (öntanımlı kategori, hatırlatıcı vb.) uyarı üretmez.
const norm = (v) => {
  if (v == null) return "";
  if (typeof v === "string") return v.trim();
  if (typeof v === "boolean" || typeof v === "number") return String(v);
  return JSON.stringify(v);
};

export const kirliMi = (suAn, baslangic) => {
  if (!baslangic || !suAn) return false;
  const anahtarlar = new Set([...Object.keys(suAn), ...Object.keys(baslangic)]);
  for (const k of anahtarlar) {
    if (norm(suAn[k]) !== norm(baslangic[k])) return true;
  }
  return false;
};

export const KIRLI_UYARI = {
  title: "Kaydedilmemiş Bilgiler",
  message: "Kaydedilmemiş bilgiler var, çıkılsın mı?",
  confirmText: "Çık",
  danger: true,
};
